module.exports = __webpack_public_path__ + "static/media/meno-piu-diritti.1ae75647.svg";